<script>
// Semáforo de la Res. 0312: SIEMPRE icono + etiqueta (nunca solo color).
export default {
  name: "StatusMark",
  props: {
    status: { type: Object, default: null }, // { key, label }
  },
};
</script>

<template>
  <span v-if="status" class="dsh-status" :class="'dsh-status--' + status.key">
    <svg class="dsh-status__icon" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">
      <template v-if="status.key === 'critical'">
        <path d="M8 1.8 15 14H1z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
        <path d="M8 6.2v3.6M8 11.6v.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      </template>
      <template v-else-if="status.key === 'warning'">
        <rect x="2.2" y="2.2" width="11.6" height="11.6" rx="2.4" fill="none" stroke="currentColor" stroke-width="1.6" transform="rotate(45 8 8)" />
        <path d="M5.4 8h5.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      </template>
      <template v-else>
        <circle cx="8" cy="8" r="6.2" fill="none" stroke="currentColor" stroke-width="1.6" />
        <path d="m5.2 8.2 2 2 3.6-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
      </template>
    </svg>
    <span class="dsh-status__label">{{ status.label }}</span>
  </span>
</template>
